import React, { Component } from "react";
import Slider from "react-slick";
// import {Row, Col} from 'react-bootstrap'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const h = 250;

class CustomSlide extends Component {

  render() {
    const { index, ...props } = this.props;
      return (
        <div {...props}></div>
      );
  }
}

export default class Responsive extends Component {

  render() {
    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 5000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (
      <div className='slick slickproject'>
        <Slider {...settings}>
          <CustomSlide className='itm' index={1}>
            <div className='bg' style={{height: h}}></div>
            <div className='desc'>
              <div className='tag'>We guarantee complete anonymity of the order.</div>
              <div className='name'>ANONYMITY</div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("#", "_self")}>
                Join Us
              </span>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={2}>
            <div className='bg' style={{height: h}}></div>
            <div className='desc'>
              <div className='tag'>More than 3 years of successful work in the field of wrapping</div>
              <div className='name'>EXPERIENCE</div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("#", "_self")}>
                Join Us
              </span>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={3}>
            <div className='bg' style={{height: h}}></div>
            <div className='desc'>
              <div className='tag'>100% guarantee from channel ban. Live people are watching you.</div>
              <div className='name'>NO BAN</div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("#", "_self")}>
                Join Us
              </span>
            </div>
          </CustomSlide>

          <CustomSlide className='itm' index={4}>
            <div className='bg' style={{height: h}}></div>
            <div className='desc'>
              <div className='tag'>No investment is required, we advertise you, we share the profit.</div>
              <div className='name'>FREE</div>
            </div>
            <div className='icon'>
               <span onClick={()=> window.open("#", "_self")}>
                Join Us
              </span>
            </div>
          </CustomSlide>

        </Slider>
      </div>
    );
  }
}
